import type { FunctionComponent } from 'react';
import type { FinanceRate } from '@kanda-libs/ks-frontend-services';
import { Price, SkeletonLoader, Text } from '@kanda-libs/ks-design-library';

import Indicator from './Indicator';
import useCreditLine from './useCreditLine';

interface CreditLineProps {
  financeOption: FinanceRate;
  onClick: (option: FinanceRate) => void;
  isLoading: boolean;
}

const CreditLine: FunctionComponent<CreditLineProps> = function ({
  financeOption,
  onClick,
  isLoading,
}) {
  const { classNames, isActive } = useCreditLine(financeOption);

  return (
    <div className={classNames.wrapper}>
      <SkeletonLoader
        isLoading={isLoading}
        height={104}
        wrapperClassName={classNames.skeletonWrapper}
        width="100%"
        afterLoading={
          <button
            type="button"
            id={`credit-line-${financeOption.name}`}
            onClick={() => onClick(financeOption)}
            className={classNames.card}
          >
            <div className={classNames.item}>
              <Text text="Max loan" className={classNames.heading} />
              <Price
                amount={financeOption?.credit_line || 0}
                poundsClassName={classNames.pounds}
                centsClassName={classNames.cents}
              />
            </div>
            <div className={classNames.item}>
              <Text text="Months" className={classNames.heading} />
              <Text
                text={String(financeOption?.duration || 0)}
                className={classNames.duration}
              />
            </div>
            <Indicator isActive={isActive} />
          </button>
        }
      />
    </div>
  );
};

CreditLine.displayName = 'CreditLines-CreditLine-view';

export default CreditLine;
